import { gsap } from 'gsap';

class CustomAnimation {
  init() {
  }

  animateHeaderImage(element){
    gsap.to(element, {
      scrollTrigger: {
        trigger: '.header',
        start: '-10% 0%',
        end: 'bottom 0%',
        markers: false,
        scrub: 0
      },
      y: '50%'
    });
  }

  animateText(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      y: 50,
      scale: .94
    });
  }

  animateGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 65%',
          markers: false,
          scrub: 0
        },
        y: 50,
        scale: .9
      });
    });
  }

  animateTextGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 65%',
          markers: false,
          scrub: 0
        },
        y: 50
      });
    });
  }

  animateScale(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      scale: .9
    });
  }

  animateScaleDown(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 30%',
        markers: false,
        scrub: 0
      },
      scale: 1.2,
      y: 50
    });
  }

  animateImage(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      y: -150
    });
  }

  animateFromLeft(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      x: -60
    });
  }

  animateFromRight(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      x: 60
    });
  }

  animateButtonHolder(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      x: 30
    });
  }

}

export default CustomAnimation;
